import { SVGProps } from "react";

const TrashCanIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="icono-basura"
      style={{ cursor: "pointer", transition: "transform 0.2s" }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3001 2.40002C10.8456 2.40002 10.4301 2.65683 10.2268 3.06337L9.35846 4.80002H5.3001C4.63736 4.80002 4.1001 5.33728 4.1001 6.00002C4.1001 6.66277 4.63736 7.20002 5.3001 7.20002L5.3001 19.2C5.3001 20.5255 6.37461 21.6 7.7001 21.6H17.3001C18.6256 21.6 19.7001 20.5255 19.7001 19.2V7.20002C20.3628 7.20002 20.9001 6.66277 20.9001 6.00002C20.9001 5.33728 20.3628 4.80002 19.7001 4.80002H15.6417L14.7734 3.06337C14.5701 2.65683 14.1546 2.40002 13.7001 2.40002H11.3001ZM8.9001 9.60002C8.9001 8.93728 9.43736 8.40002 10.1001 8.40002C10.7628 8.40002 11.3001 8.93728 11.3001 9.60002V16.8C11.3001 17.4628 10.7628 18 10.1001 18C9.43736 18 8.9001 17.4628 8.9001 16.8V9.60002ZM14.9001 8.40002C14.2374 8.40002 13.7001 8.93728 13.7001 9.60002V16.8C13.7001 17.4628 14.2374 18 14.9001 18C15.5628 18 16.1001 17.4628 16.1001 16.8V9.60002C16.1001 8.93728 15.5628 8.40002 14.9001 8.40002Z"
        fill="white"
      />
    </svg>
  );
};

export default TrashCanIcon;
